import { createFeatureSelector, createSelector } from '@ngrx/store'
import {
  PROJECTOR_CONTAINERS_FEATURE_KEY,
  ProjectorContainerState,
  projectorContainerAdapter,
} from './projector-containers.reducer'

export const selectProjectorContainerState = createFeatureSelector<ProjectorContainerState>(
  PROJECTOR_CONTAINERS_FEATURE_KEY,
)

const { selectAll: selectAllProjectorContainers, selectEntities: selectProjectorContainerEntities } =
  projectorContainerAdapter.getSelectors()

export const selectProjectorContainersLoaded = createSelector(selectProjectorContainerState, (state) => state.loaded)

export const selectAllProjectorContainersList = createSelector(selectProjectorContainerState, (state) =>
  selectAllProjectorContainers(state),
)

export const selectProjectorContainerEntitiesMap = createSelector(selectProjectorContainerState, (state) =>
  selectProjectorContainerEntities(state),
)

export const selectSelectedProjectorContainerId = createSelector(
  selectProjectorContainerState,
  (state) => state.selectedId,
)

export const selectSelectedProjectorContainer = createSelector(
  selectProjectorContainerEntitiesMap,
  selectSelectedProjectorContainerId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined),
)

export const selectProjectorContainersEditCreateLoaded = createSelector(
  selectProjectorContainerState,
  (state) => state.editCreateLoaded,
)

export const selectProjectorContainerDataIsLoading = createSelector(
  selectProjectorContainerState,
  (state) => state.isLoading,
)

export const selectProjectorContainerDataIsReady = createSelector(
  selectProjectorContainerState,
  (state) => state.isReady,
)
